@let filters = filters$ | async;
@for (filter of filters; track filter.id) {
  <tm-filter-list-item [filterGroup]="filter" [editFiltersExpanded]="filters?.length === 1"></tm-filter-list-item>
}
